import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'react-recompose';
import { withEnabledFeatures } from '../../utils/features';

const FeatureEnabledComponent = ({ enabledFeatures, allOf, anyOf, children }) =>
  ((allOf) ? [].concat(allOf).every((feature) => enabledFeatures.includes(feature)) && children :
    [].concat(anyOf).some((feature) => enabledFeatures.includes(feature)) && children);

const FeatureEnabled = compose(
  setDisplayName('FeatureEnabled'),
  withEnabledFeatures,
)(FeatureEnabledComponent);
FeatureEnabled.propTypes = {
  allOf: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  anyOf: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};
export default FeatureEnabled;
